if (!customElements.get('social-feeds-section')) {
  class SocialFeedsSection extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('.social-feeds-modal');
      this.panels = Array.from(this.querySelectorAll('.social-feeds-modal__panel'));
      this.postButtons = Array.from(this.querySelectorAll('[data-social-feed-open]'));
      this.currentIndex = 0;

      this.postButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.socialFeedOpen);
          this.openModal(index, button);
        });
      });

      this.querySelectorAll('[data-social-feed-prev]').forEach((button) => {
        button.addEventListener('click', () => this.showSlide(this.currentIndex - 1));
      });

      this.querySelectorAll('[data-social-feed-next]').forEach((button) => {
        button.addEventListener('click', () => this.showSlide(this.currentIndex + 1));
      });
    }

    openModal(index, opener) {
      if (!this.modal) return;

      this.showSlide(index);
      this.modal.open(opener);
    }

    showSlide(index) {
      if (!this.panels.length) return;

      const total = this.panels.length;
      this.currentIndex = Math.max(0, Math.min(index, total - 1));

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === this.currentIndex;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        const video = panel.querySelector('video');
        if (!video) return;

        if (isActive) {
          video.currentTime = 0;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      this.querySelectorAll('[data-social-feed-prev]').forEach((button) => {
        button.disabled = this.currentIndex === 0;
      });

      this.querySelectorAll('[data-social-feed-next]').forEach((button) => {
        button.disabled = this.currentIndex === total - 1;
      });
    }
  }

  customElements.define('social-feeds-section', SocialFeedsSection);
}
